export class PurchaseConfig {
  numberOfSalesDaysForStock: number;
  stockAlertThresholdDays: number;
  forecastStockAlertThresholdDays: number;
  reorderStockDays: number;
  safetyStockDays: number;
  defaultSalesGrowthPercent: number;
  autoOrderExcludedTagIds: number[];
  suggestionQuantityRounding: 'moq' | 'box' | 'none';

  prefixSupplierOrder: string = 'SUP/{year}/';
  textSupplierOrderHeader: string = '';
  textSupplierOrderFooter: string = '';
  textShippingAddress: string = '';
  supplierOrderEmailCc: string = '';
  attachExcelToSupplierOrderEmail: boolean = true;

  showProductImages?: boolean = true;

  requireSerialSelection?: boolean = true;
  requireBatchSelection?: boolean = true;

  limitQuickReceptionToSupplierProducts?: boolean = true;

  closeOnPartialReceptionByDefault?: boolean = false;
  createBackOrderByDefault?: boolean = false;

  // Sending an order below the supplier price / weight threshold
  supplierOrderThresholdCheck?: 'none' | 'warn' | 'block' = 'warn';

  constructor() {
    this.numberOfSalesDaysForStock = 30;
    this.stockAlertThresholdDays = 7;
    this.forecastStockAlertThresholdDays = 14;
    this.reorderStockDays = 14;
    this.safetyStockDays = 0;
    this.defaultSalesGrowthPercent = 0;
    this.autoOrderExcludedTagIds = [];
    this.suggestionQuantityRounding = 'moq';
    this.showProductImages = true;
    this.requireSerialSelection = true;
    this.requireBatchSelection = true;
    this.limitQuickReceptionToSupplierProducts = true;
    this.closeOnPartialReceptionByDefault = false;
    this.createBackOrderByDefault = false;
    this.supplierOrderThresholdCheck = 'warn';
  }
}
